import classNames from "classnames";
import * as styles from "./InstallStyles.scss";
import { Button, Title } from "@yoast/ui-library";
import { defineMessages, FormattedMessage } from "react-intl";
import React, { useContext } from "react";
import ButtonsContainer from "../general/ButtonsContainer";
import { ArrowLongLeftIcon, ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid";
import { InstallContext } from "./InstallContext";


const messages = defineMessages( {
	title: {
		id: "finish.title",
		defaultMessage: "You've successfully completed the installation! 🎉",
	},
	body: {
		id: "finish.body",
		defaultMessage: "You're ready to start optimizing your site!",
	},
	closeNotice: {
		id: "finish.closeNotice",
		defaultMessage: "You can safely close this window or go to MyYoast to manage your subscriptions.",
	},
	back: {
		id: "install.button.back",
		defaultMessage: "Back",
	},
	continueButton: {
		id: "install.button.continue",
		defaultMessage: "Go to MyYoast",
	},
} );

/**
 * The last step of the installation flow, confirming the installation is complete.
 * @returns {Element} The JSX Element.
 */
export const FinishStep = () => {
	const { steps, goToPreviousStep } = useContext( InstallContext );

	const navigateToMyYoast = () => {
		window.open( "/", "_self" );
	};

	return (
		<div className={ classNames( styles.downloadingStep, styles.ySpacing ) }>
			<Title className={ styles.textCenter }><FormattedMessage { ...messages.title } /></Title>
			<hr />
			<p className={ styles.textCenter }>
				<FormattedMessage { ...messages.body } />
			</p>
			<p className={ styles.textCenter }>
				<FormattedMessage tagName="em" { ...messages.closeNotice } />
			</p>
			<hr />
			<ButtonsContainer className={ styles.buttonContainer }>
				{ steps.canGoBack && <Button variant="tertiary" onClick={ goToPreviousStep }>
					<ArrowLongLeftIcon className={ styles.buttonIcon } />
					<FormattedMessage { ...messages.back } />
				</Button> }
				<Button variant="tertiary" onClick={ navigateToMyYoast }>
					<FormattedMessage { ...messages.continueButton } />
					<ArrowTopRightOnSquareIcon className={ styles.buttonIcon } />
				</Button>
			</ButtonsContainer>
		</div>
	);
};
